import script from "./ImageThumbnails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageThumbnails.vue?vue&type=script&setup=true&lang=ts"

import "./ImageThumbnails.vue?vue&type=style&index=0&id=2139de6a&lang=postcss&scoped=true"

import exportComponent from "/var/www/keyvue-customer-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2139de6a"]])

export default __exports__